module.exports = __webpack_public_path__ + "static/media/wine-glass.75c20d15.svg";